/**
 * Internal dependencies
 */
import CONFIG from './config-values';
/**
 * @param {keyof CONFIG} name The variable name
 * @return {string} The variable
 */

export var config = function config(name) {
  return CONFIG[name];
};
//# sourceMappingURL=config.js.map